module.exports = __webpack_public_path__ + "img/2024_YouthShirt.175b54d6.jpg";